export const isAlways = (c) => 'always' in c;
export const isNever = (c) => 'never' in c;
export const isLeaf = (c) => !('allOf' in c) && !('anyOf' in c) && !('always' in c) && !('never' in c);
export const mapLeaves = (c, fn) => {
    if ('always' in c || 'never' in c)
        return c;
    if ('allOf' in c)
        return { allOf: c.allOf.map((child) => mapLeaves(child, fn)) };
    if ('anyOf' in c)
        return { anyOf: c.anyOf.map((child) => mapLeaves(child, fn)) };
    return fn(c);
};
export const collectLeaves = (c) => {
    if ('always' in c || 'never' in c)
        return [];
    if ('allOf' in c)
        return c.allOf.flatMap(collectLeaves);
    if ('anyOf' in c)
        return c.anyOf.flatMap(collectLeaves);
    return [c];
};
export const fieldNames = (c) => {
    const names = new Set();
    for (const leaf of collectLeaves(c)) {
        if (leaf.fieldName)
            names.add(leaf.fieldName);
    }
    return [...names];
};
export const evaluate = (c, evalLeaf) => {
    if ('always' in c)
        return true;
    if ('never' in c)
        return false;
    if ('allOf' in c)
        return c.allOf.every((child) => evaluate(child, evalLeaf));
    if ('anyOf' in c)
        return c.anyOf.some((child) => evaluate(child, evalLeaf));
    return evalLeaf(c);
};
export const format = (c, fmtLeaf, audience = 'llm') => {
    if ('always' in c)
        return audience === 'ui' ? 'always' : 'ALWAYS';
    if ('never' in c)
        return audience === 'ui' ? 'never' : 'NEVER';
    const andWord = audience === 'ui' ? ' and ' : ' AND ';
    const orWord = audience === 'ui' ? ' or ' : ' OR ';
    if ('allOf' in c) {
        const parts = c.allOf.map((child) => format(child, fmtLeaf, audience));
        if (parts.length === 1)
            return parts[0];
        return `(${parts.join(andWord)})`;
    }
    if ('anyOf' in c) {
        const parts = c.anyOf.map((child) => format(child, fmtLeaf, audience));
        if (parts.length === 1)
            return parts[0];
        return `(${parts.join(orWord)})`;
    }
    return fmtLeaf(c, audience);
};
export const TEXT_MATCH_LABEL = {
    begins_with: 'begins with',
    not_begins_with: 'does not begin with',
    ends_with: 'ends with',
    not_ends_with: 'does not end with'
};
// "Unit Number begins with UNK", "Email ends with WALMART.COM (any case)"
export const formatTextMatch = (c, name) => `${name} ${TEXT_MATCH_LABEL[c.operation]} ${c.expectedValue}${c.ignoreCase ? ' (any case)' : ''}`;
export const filterLeaves = (c, predicate) => {
    if ('always' in c)
        return c;
    if ('never' in c)
        return c;
    if ('allOf' in c) {
        const children = c.allOf
            .map((child) => filterLeaves(child, predicate))
            .filter((x) => x != null);
        if (children.length === 0)
            return undefined;
        if (children.length === 1)
            return children[0];
        return { allOf: children };
    }
    if ('anyOf' in c) {
        const children = c.anyOf
            .map((child) => filterLeaves(child, predicate))
            .filter((x) => x != null);
        if (children.length === 0)
            return undefined;
        if (children.length === 1)
            return children[0];
        return { anyOf: children };
    }
    return predicate(c) ? c : undefined;
};
export const fromDNF = (group) => {
    const branches = group.filter((g) => g.length > 0);
    if (branches.length === 0)
        return undefined;
    const toAnd = (leaves) => leaves.length === 1 ? leaves[0] : { allOf: leaves };
    if (branches.length === 1)
        return toAnd(branches[0]);
    return { anyOf: branches.map(toAnd) };
};
export const normalize = (c) => {
    if (!c)
        return undefined;
    if (Array.isArray(c))
        return fromDNF(c);
    if (typeof c === 'object' &&
        c !== null &&
        ('allOf' in c || 'anyOf' in c || 'fieldName' in c || 'always' in c || 'never' in c))
        return c;
    return undefined;
};
//# sourceMappingURL=form-condition.js.map